import MDBox from "components/MDBox"
import MDTypography from "components/MDTypography"
import { formatDate } from "../constants"

// Notes left on past actions, oldest first. actionLog is the flat source;
// approvalProgress[].actions is the fallback for payloads without it.
export const collectActionNotes = (actionLog, approvalProgress) => {
  const entries = actionLog?.length
    ? actionLog
    : (approvalProgress || []).flatMap((s) => s.actions || [])
  return entries
    .filter((a) => a.note)
    .map((a) => ({
      actor: typeof a.actor === "number" ? `User #${a.actor}` : a.actor || "Someone",
      action: a.action || a.type,
      at: a.actedAt || a.at,
      note: a.note,
    }))
}

const ActionNotes = ({ notes }) => {
  if (!notes?.length) return null
  return (
    <MDBox mt={2} pt={2} sx={{ borderTop: "1px solid", borderColor: "grey.300" }}>
      <MDTypography variant="caption" fontWeight="bold" color="text" textTransform="uppercase" display="block" mb={1}>
        Notes
      </MDTypography>
      {notes.map((n, i) => {
        const isResubmit = String(n.action).toLowerCase() === "resubmit"
        return (
        <MDBox
          key={i}
          mb={1}
          sx={isResubmit ? { backgroundColor: "warning.light", borderLeft: "3px solid", borderColor: "warning.main", borderRadius: 1, px: 1, py: 0.5 } : undefined}
        >
          <MDTypography variant="caption" color="text" display="block">
            {n.actor} · {isResubmit ? "resubmit (updated)" : n.action}
            {n.at ? ` · ${formatDate(n.at)}` : ""}
          </MDTypography>
          <MDTypography variant="button" color="dark" display="block" sx={{ overflowWrap: "anywhere" }}>
            “{n.note}”
          </MDTypography>
        </MDBox>
        )
      })}
    </MDBox>
  )
}

export default ActionNotes
